<template>
  <AppConfirm
    title="Confirm changes"
    confirm-label="Save"
    size="slarge"
    @confirm="$emit('confirm')"
    @cancel="$emit('close')"
  >
    Changing this member's role will move them from a free seat to a paid seat and will increase the number of paid
    seats on your plan.
  </AppConfirm>
</template>

<script>
export default {
  name: 'ConfirmSeatsIncreaseDialog',
  emits: ['confirm', 'close'],
};
</script>
